// extracted by mini-css-extract-plugin
export default {"BreadCrumbs":"BreadCrumbs_BreadCrumbs__vcf1U","active":"BreadCrumbs_active__ZMrLR"};